const prd = [
    {
        depth2: '고객정보입력',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '고객정보입력',
        type: 'PAGE',
        dir: 'com',
        id: 'SC-COM-1021-F',
        plan: '25.05.20',
        end: '25.05.02',
        user: '김익중',
        state: '삭제',
        etc: '25.05.12 : SC-COM-1021-F 페이지와 동일',
    },
    {
        depth2: '입출금',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '입출금 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1000-F',
        plan: '25.05.16',
        end: '25.05.13',
        user: '허재성',
        state: '수정',
        etc: '250520: 탭메뉴명 수정, 250909 예금금리 케이스 추가',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '입출금 상품상세(IBK주거래생활금융통장)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1011-F',
        plan: '25.04.23',
        end: '25.04.22',
        user: '허재성',
        state: '완료',
        etc: '250428:기존 화면 소스로 일부 수정, 250512: 폰트색상수정 및 약관버튼 제목많을시 아이콘 줄어드는현상 수정, 250516: 구분바 제거, 250618:간격수정',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '입출금 상품상세(IBK중기근로자급여파킹통장)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1011-F01',
        plan: '25.04.23',
        end: '25.04.22',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '입출금 상품상세(IBK 간편한 통장)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1011-F02',
        plan: '25.04.23',
        end: '25.04.22',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '입출금 상품상세(IBK나라사랑통장[입출금식])',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1011-F03',
        plan: '25.04.23',
        end: '25.04.22',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '입출금 상품상세(IBK개인입출통장)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1011-F04',
        plan: '25.04.23',
        end: '25.04.22',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품가입',
        depth4: '상품약관동의',
        depth5: '',
        name: '입출금 상품약관동의',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1012-F',
        plan: '25.05.09',
        end: '25.05.08',
        user: '허재성',
        state: '완료',
        etc: '250502:상품안내 수단선택 체크박스 작업중, 250509:상품안내 문구수정 및 헤더수정, 250514:마침표누락 수정, 250515: SC-PDM-1013-P 포함,250528: SC-COM-0006-P 내용포함, 250604: 개인(신용)정보 수집 · 이용동의서, 상품서비스 안내 체크박스 수정, 20250610:구조변경 재코딩, 250619: 마침표 추가, 250829 약관동의 위치 수정',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품가입',
        depth4: '한도계좌 개설 안내',
        depth5: '',
        name: '한도계좌 개설 안내',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-1013-P',
        plan: '25.05.16',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '250515: SC-COM-0012-P 바텀시트 한도제한 버튼클릭시 노출됨, 250516: SC-COM-0012-P 내용수정,250605:페이지 재코딩, 250610:SC-COM-0013-P -> SC-PDM-1013-P 아이디변경 및 문구수정 ',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품가입',
        depth4: '평생계좌번호 등록',
        depth5: '',
        name: '평생계좌번호 등록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1014-F',
        plan: '25.05.16',
        end: '25.05.07',
        user: '허재성',
        state: '완료',
        etc: '250509: 관리지점 및 직원을 선택하세요 영역 버튼으로 변경, 250509: 타이틀 크기변경, 250514:step 오류 및 마침표 누락 수정, 250610:아이디변경SC-COM-0011-F -> SC-PDM-1014-F 및 구조변경 재코딩, 250827 관리지점 / 평생계좌번호 수정',
        uxw: true,
    },
    {
        depth2: '입출금',
        depth3: '상품가입',
        depth4: '평생계좌번호 등록 안내',
        depth5: '',
        name: '평생계좌번호 등록 안내',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-1015-P',
        plan: '25.06.10',
        end: '25.06.10',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },

    {
        depth2: '입출금',
        depth3: '상품가입',
        depth4: '입출금 가입완료',
        depth5: '',
        name: '입출금 가입완료',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-1016-F',
        plan: '25.05.16',
        end: '24.05.12',
        user: '허재성',
        state: '완료',
        etc: '250515: SC-COM-0012-P 바텀시트 한도제한 버튼클릭시 노출됨., 250516: SC-COM-0012-P 내용수정,250610:SC-COM-0015F->SC-PDM-1016-F변경 텍스트 및 버튼추가, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '적금·청약 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2000-F',
        plan: '25.05.16',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '250520: 탭메뉴명 수정',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '적금·청약 상품상세(주택청약종합저축)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2011-F',
        plan: '25.06.13',
        end: '25.06.02',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '적금·청약 상품상세(IBK D-day적금)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2011-F01',
        plan: '25.06.13',
        end: '25.06.02',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품상세',
        depth4: '상품약관동의',
        depth5: '',
        name: '적금·청약 상품약관동의',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2013-F',
        plan: '25.06.17',
        end: '25.06.11',
        user: '허재성',
        state: '완료',
        etc: '현재소스, 250619: 마침표 추가, 250829 약관동의 위치 수정',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품상세',
        depth4: '가입정보입력A',
        depth5: '',
        name: '적금·청약 가입정보입력A',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2014-F',
        plan: '25.06.17',
        end: '25.06.17',
        user: '허재성',
        state: '완료',
        etc: '최초 소스,250701:인풋 영역 추가 및 수정, 250828 관리지점 수정',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품상세',
        depth4: '가입정보입력A',
        depth5: '우대금리조건',
        name: '우대금리조건',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2015-P',
        plan: '25.06.20',
        end: '25.06.12',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품상세',
        depth4: '가입정보입력A',
        depth5: '만기해지방법',
        name: '만기해지방법',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2016-P',
        plan: '25.06.20',
        end: '25.06.13',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '디데이설정',
        depth5: '',
        name: '적금·청약 디데이설정',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2017-F',
        plan: '25.06.20',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '테마설정',
        depth5: '',
        name: '적금·청약 테마설정',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2018-F',
        plan: '25.06.11',
        end: '25.05.27',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250625:아이탄생영역 추가',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력B',
        depth5: '',
        name: '적금·청약 가입정보입력B',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2019-F',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250625:아이탄생 이미지 추가,250701:영역추가및 문구수정, 250828 관리지점 수정',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '적금·청약 내용확인',
        depth5: '',
        name: '적금·청약 내용확인',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2020-F',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250701:문구추가',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '적금·청약 가입완료',
        depth5: '',
        name: '적금·청약 가입완료',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2021-F',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250701:문구추가, 250715: 체크이미지 로띠변경, 250721:클레스 추가',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '자동 이체일 설정 (주기)',
        name: '자동 이체일 설정 (주기)',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2022-P',
        plan: '25.06.20',
        end: '25.06.12',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '자동 이체일 설정 (일)',
        name: '자동 이체일 설정 (일)',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2023-P',
        plan: '25.06.20',
        end: '25.06.12',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '자동 이체일 설정 (요일)',
        name: '자동 이체일 설정 (요일)',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2024-P',
        plan: '25.06.20',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '자동이체 시작일',
        name: '자동이체 시작일',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2025-P',
        plan: '25.06.20',
        end: '25.06.13',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '희망입주정보',
        depth5: '',
        name: '희망입주정보',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-2026-F',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '희망입주정보',
        depth5: '시/도 선택',
        name: '시/도 선택',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2027-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '희망입주정보',
        depth5: '구/군 선택',
        name: '구/군 선택',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2028-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '희망입주정보',
        depth5: '희망주택형',
        name: '희망주택형',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2029-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '희망입주정보',
        depth5: '희망주택면적(전용면적)',
        name: '희망주택면적(전용면적)',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2030-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '희망입주정보',
        depth5: '희망입주시기',
        name: '희망입주시기',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2031-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '가입기간(년)',
        name: '가입기간(년)',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2033-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '가입기간(월)',
        name: '가입기간(월)',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2034-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '가입정보입력A',
        depth5: '가입기간',
        name: '가입기간',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2035-P',
        plan: '25.06.17',
        end: '25.06.16',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '적금·청약',
        depth3: '상품가입',
        depth4: '이체계좌확인',
        depth5: '',
        name: '이체계좌확인',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-2036-F',
        plan: '25.06.17',
        end: '25.06.16',
        user: '허재성',
        state: '완료',
        etc: '최신소스, 250721:클레스 수정',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '예금·중금채 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3000-F',
        plan: '25.05.16',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '250520: 탭메뉴명 수정',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '예금·중금채 상품상세',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3011-F',
        plan: '25.06.20',
        end: '25.06.19',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '목록',
        depth4: '상품약관동의',
        depth5: '',
        name: '예금·중금채가입 > 예금·중금채 상품약관동의',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3012-F',
        plan: '25.06.20',
        end: '25.06.17',
        user: '허재성',
        state: '완료',
        etc: '현재소스, 250619: 마침표추가, 250829 약관동의 위치 수정',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '가입정보입력',
        depth4: '',
        depth5: '',
        name: '예금·중금채가입 > 예금·중금채 가입정보입력',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3013-F',
        plan: '25.06.20',
        end: '25.06.17',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250702:영역수정 및 문구추가, 250828 관리지점 수정',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '예금·중금채 가입완료',
        depth4: '',
        depth5: '',
        name: '예금·중금채가입 > 예금·중금채가입완료',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3015-F',
        plan: '25.06.20',
        end: '25.06.17',
        user: '허재성',
        state: '완료',
        etc: '최신소스, 250702: li영역 추가, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '예금∙중금채 내용확인',
        depth4: '',
        depth5: '',
        name: '예금·중금채가입 > 예금∙중금채 내용확인',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3017-F',
        plan: '25.06.20',
        end: '25.06.17',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250702: 문구수정',
        uxw: true,
    },
    {
        depth2: '예금·중금채',
        depth3: '상품약관동의',
        depth4: '우대금리(마케팅동의)',
        depth5: '',
        name: '우대금리(마케팅동의)',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-3018-P',
        plan: '25.06.20',
        end: '',
        user: '허재성',
        state: '삭제',
        etc: '',
    },
    {
        depth2: '체크카드',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '체크카드 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4000-F',
        plan: '25.05.16',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '250520: 탭메뉴명 수정, 250521:카드이미지 수정, 250709:해시테크 추가',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '상품상세',
        depth4: '',
        depth5: '',
        name: '체크카드 상품상세',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4001-F',
        plan: '25.06.24',
        end: '25.06.17',
        user: '허재성',
        state: '완료',
        etc: '최신소스, 250714:체크카드이미지 추가',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '상품약관동의',
        depth4: '',
        depth5: '',
        name: '체크카드가입 > 체크카드 상품약관동의',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4002-F',
        plan: '25.06.20',
        end: '25.06.19',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '신청정보입력',
        depth4: '',
        depth5: '',
        name: '체크카드가입 > 체크카드 신청정보입력',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4003-F',
        devUrl: 'prd/crd/PRDCRD0107.tsx',
        plan: '25.06.20',
        end: '25.06.18',
        user: '허재성',
        state: '완료',
        etc: '250828 관리지점 수정',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '서비스신청',
        depth4: '',
        depth5: '',
        name: '체크카드가입 > 체크카드 서비스신청',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4004-F',
        plan: '25.06.20',
        end: '25.06.18',
        user: '허재성',
        state: '완료',
        etc: '25.06.18 최초완료, 25.07.03 기획수정반영',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '서비스신청',
        depth4: 'case',
        depth5: '',
        name: '체크카드가입 > 체크카드 서비스신청',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4004-F1',
        plan: '25.06.20',
        end: '25.06.18',
        user: '허재성',
        state: '완료',
        etc: '특정 학생증 카드 경우 꼭 알아두세요 문구 케이스',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '비밀번호 설정',
        depth4: '',
        depth5: '',
        name: '체크카드가입 > 체크카드 비밀번호 설정',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4005-F',
        plan: '25.06.20',
        end: '25.06.18',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '체크카드',
        depth3: '체크카드 가입완료',
        depth4: '',
        depth5: '',
        name: '체크카드가입 > 체크카드 체크카드 가입완료',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-4006-F',
        plan: '25.06.20',
        end: '25.06.18',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250702:꼭알아두세요영역수정, 250715: 체크이미지 로띠변경',
        uxw: true,
    },
    {
        depth2: '신용카드',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '신용카드 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-5000-F',
        plan: '25.05.16',
        end: '25.05.16',
        user: '허재성',
        state: '완료',
        etc: '롤링베너 디자인변경예정, 250515: SC-PDM-2032-P 바텀시트 포함되어있음, 250520: 탭메뉴명 수정, 250711: 해시태그 추가',
        uxw: true,
    },
    {
        depth2: '신용카드',
        depth3: '상세',
        depth4: '',
        depth5: '',
        name: '신용카드 상세',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-5001-F',
        plan: '25.05.16',
        end: '25.05.16',
        user: '허재성',
        state: '완료',
        etc: '250521 카드이미지 수정, 250611: 카드상세 아이콘 추가, 250613:UX Writing1.2 수정',
        uxw: true,
    },
    {
        depth2: '대출',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '대출 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-6000-F',
        plan: '25.05.16',
        end: '25.05.12',
        user: '허재성',
        state: '완료',
        etc: '250515: SC-PDM-2032-P 바텀시트 포함되어있음, 250520: 탭메뉴명 수정',
        uxw: true,
    },
    {
        depth2: '대출',
        depth3: '상세',
        depth4: '',
        depth5: '',
        name: '대출 상세',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-6001-F',
        plan: '25.05.23',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '250516: 구분바 제거, 250520: 버튼명변경, 250620:UX Writing 수정, 250716:클레스 추가',
        uxw: true,
    },
    {
        depth2: '보험',
        depth3: '목록',
        depth4: '',
        depth5: '',
        name: '보험 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-7000-F',
        plan: '25.05.16',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '250520: 탭메뉴명 수정, 250728:보험목록 재코딩',
        uxw: true,
    },
    {
        depth2: '보험',
        depth3: '상세',
        depth4: '',
        depth5: '',
        name: '보험 상세',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-7001-F',
        plan: '25.05.23',
        end: '25.05.13',
        user: '허재성',
        state: '완료',
        etc: '최근소스, 250620:UX Writing 수정, 250716:클레스 추가',
        uxw: true,
    },
    {
        depth2: '퇴직연금(IRP)',
        depth3: '개인형IRP',
        depth4: '',
        depth5: '',
        name: '퇴직연금(IRP) 개인형IRP',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-8000-F',
        plan: '25.05.23',
        end: '25.05.19',
        user: '허재성',
        state: '수정',
        etc: '최초소스, 250620:UX Writing 수정, 250908 디자인 수정',
        uxw: true,
    },
    {
        depth2: 'ISA',
        depth3: '',
        depth4: '',
        depth5: '',
        name: 'ISA',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-8100-F',
        plan: '25.05.23',
        end: '25.05.19',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250620:UX Writing 수정',
        uxw: true,
    },
    {
        depth2: '펀드',
        depth3: '',
        depth4: '',
        depth5: '',
        name: '펀드',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-8200-F',
        plan: '25.05.23',
        end: '25.05.19',
        user: '허재성',
        state: '완료',
        etc: '',
        etc: '최초소스, 250620:UX Writing 수정, 250806:클래스 변경',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보가입 안내',
        depth4: '',
        depth5: '',
        name: '콤보가입 > 콤보가입 안내',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9001-F',
        plan: '25.07.04',
        end: '25.06.30',
        user: '허재성',
        state: '완료',
        etc: '최초소스, 250716:문구위치 수정, 250904 기획/디자인 수정',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보가입 목록',
        depth4: '',
        depth5: '',
        name: '콤보가입 > 콤보가입 목록',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9002-F',
        plan: '25.07.04',
        end: '25.06.30',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보상품 상세',
        depth4: '',
        depth5: '',
        name: '콤보가입 > 콤보상품 상세',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9005-F',
        plan: '25.07.04',
        end: '',
        user: '허재성',
        state: '삭제',
        etc: '',
        uxw: false,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보상품 신청하기',
        depth4: '',
        depth5: '',
        name: '콤보가입 > 콤보상품 신청하기',
        type: 'POPUP',
        dir: 'prd',
        id: 'SC-PDM-9006-P',
        plan: '25.07.04',
        end: '25.06.30',
        user: '허재성',
        state: '완료',
        etc: '',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보상품 진행안내',
        depth4: '스마트뱅킹 가입',
        depth5: '',
        name: '콤보상품 진행안내 스마트뱅킹 가입',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9009-F01',
        plan: '25.07.04',
        end: '25.06.30',
        user: '김익중',
        state: '완료',
        etc: '최초완료, 250904 기획/디자인 수정',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보상품 진행안내',
        depth4: '적금계좌 개설',
        depth5: '',
        name: '콤보상품 진행안내 적금계좌 개설',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9009-F02',
        plan: '25.07.04',
        end: '25.06.30',
        user: '김익중',
        state: '완료',
        etc: '최초완료, 250904 기획/디자인 수정',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보상품 진행안내',
        depth4: '체크카드 신청',
        depth5: '',
        name: '콤보상품 진행안내 체크카드 신청',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9009-F03',
        plan: '25.07.04',
        end: '25.06.30',
        user: '허재성',
        state: '완료',
        etc: '최초완료, 250904 기획/디자인 수정',
        uxw: true,
    },
    {
        depth2: '콤보케이스',
        depth3: '콤보상품 진행안내',
        depth4: '가입완료',
        depth5: '',
        name: '콤보상품 진행안내 가입완료',
        type: 'PAGE',
        dir: 'prd',
        id: 'SC-PDM-9009-F04',
        plan: '25.07.04',
        end: '25.06.30',
        user: '김익중',
        state: '완료',
        etc: '',
        uxw: true,
    },
]

export default prd
